import { Module } from 'vuex';
import { APP_ROUTE_LOADING } from '../mutation-types';
import { RootState } from '../types';

interface AppState {
  routeLoading: boolean;
}

const app: Module<AppState, RootState> = {
  namespaced: true,
  state: {
    routeLoading: false
  },
  getters: {
    routeLoading: state => state.routeLoading
  },
  actions: {
    setRouteLoading({ commit }, loading) {
      commit(APP_ROUTE_LOADING, loading);
    }
  },
  mutations: {
    [APP_ROUTE_LOADING](state, path) {
      state.routeLoading = path;
    }
  }
};

export default app;
